export default __webpack_public_path__ + "static/AhypnoticSwedishtradition-1c7ccfa4345f810a5ec31246d08f1f9a.jpg";